import { render, staticRenderFns } from "./setKeywords.vue?vue&type=template&id=19e46f11"
import script from "./setKeywords.vue?vue&type=script&lang=js"
export * from "./setKeywords.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports